import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M23.48 22.65a.83.83 0 0 1-.83.82H9.35a.83.83 0 0 1-.83-.82V9.35a.83.83 0 0 1 .83-.82h5.85V7.22H9.35a2.13 2.13 0 0 0-2.12 2.13v13.3a2.13 2.13 0 0 0 2.12 2.13h13.3a2.13 2.13 0 0 0 2.12-2.13v-5.84h-1.29z' }),
  React.createElement('path', { d: 'M23.39 7.22h-3.77v1.31h2.94l-6.9 6.89.91.92 6.91-6.9v2.94h1.29V8.61a1.39 1.39 0 0 0-1.38-1.39z' })
));